import { createStateLoader } from 'Common/components/app';
import { product } from '~features';

export default createStateLoader({
    setState: product.actions.setItemDetails,
    clearState: product.actions.clearItemDetails,
});
